export default __webpack_public_path__ + "static/media/218.2c260532.png";